import { Translation, useTranslation } from 'react-i18next'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import React, { memo, useCallback, useState, useEffect, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { InputLabel, MenuItem, FormControl, Select } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDownOutlined'
import Chip from '@material-ui/core/Chip'
import * as _ from 'lodash'
import { useApolloClient } from '@apollo/react-hooks'
import cuid from 'cuid'

import { Locations } from './components'
import Header from './header'
import styles from './styles'
import { StoreValue, CompanyQuery, CheckCredentialsQuery } from 'store'
import { EntityLogo, Loading } from 'components'
import { EEntity, ECompanyActionTypes, EAppStateActionTypes } from 'models'
import classNames from 'classnames'
import Input from '@material-ui/core/Input'
import {
	useCompanyTypeCollectionQuery,
	useIndustryCollectionQuery,
	useInsertIntoCompanyCollectionMutation,
} from 'graphql/__generated__/graphql'

const companySize: { [key: string]: any } = {
	ZeroTen: '0-10',
	TenFifty: '10-50',
	FyftyOneHundred: '50-100',
	OneHundredTwoHundred: '100-200',
	TwoHundredFiveHundred: '200-500',
	FiveHundredOneThousand: '500-1000',
	OneThousandThreeThousand: '1000-3000',
	ThreeThousandTenThousand: '3000-10000',
	OverTenThousand: '10000+',
}

const useStyles = makeStyles(styles)
const STEP_1 = 'step1'
const STEP_2 = 'step2'

const CompanyCreateView: React.FunctionComponent<any> = props => {
	const {
		storeUserId,
		// storeUserIg,
		id,
		name,
		description,
		industryId,
		typeId,
		noOfEmployees,
		hasLogo,
		logoPath,
		offices,
		storeDispatch,
		headquarters,
		storeUser,
		error,
	} = props
	const client = useApolloClient()
	const history = useHistory()
	const classes = useStyles()
	const { t, i18n } = useTranslation()
	const [loading, toggle] = useState(false)

	const [step, setStep] = useState(STEP_1)
	const [isAvatarUploaded, setIsAvatarUploaded] = useState(false)
	const [isCompanyNameAvailable, setIsCompanyNameAvailable] = useState<
		boolean | ''
	>('')
	const isHeadquartersAvailable = useMemo(
		() => headquarters && headquarters.selected.length === 1,
		[headquarters],
	)
	const [checkCompanyLoading, setCheckCompanyLoading] = useState(false)

	// select industries and company types
	const { data: industriesData = {} } = useIndustryCollectionQuery()
	const { data: companyTypesData = {} } = useCompanyTypeCollectionQuery()

	if (
		companyTypesData &&
		companyTypesData.companyTypeCollection?.edges &&
		typeId === ''
	) {
		storeDispatch({
			type: ECompanyActionTypes.setTypeId,
			typeId: companyTypesData?.companyTypeCollection.edges[0]?.node.id,
		})
	}

	const handleLogoUpload = useCallback(
		(hasLogo: boolean, logoPath: string) => {
			storeDispatch({
				type: ECompanyActionTypes.setUploadLogo,
				hasLogo,
				logoPath,
			})
		},
		[storeDispatch],
	)

	const updateCompanyName = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			storeDispatch({
				type: ECompanyActionTypes.setName,
				name: e.target.value,
			})
		},

		[storeDispatch],
	)
	const updateCompanyType = useCallback(
		(typeId: any) => {
			storeDispatch({
				type: ECompanyActionTypes.setTypeId,
				typeId: typeId,
			})
		},
		[storeDispatch],
	)
	const updateCompanySize = useCallback(
		(noOfEmployees: any) => {
			storeDispatch({
				type: ECompanyActionTypes.setNoOfEmployees,
				noOfEmployees,
			})
		},
		[storeDispatch],
	)

	const updateCompanyDescription = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			storeDispatch({
				type: ECompanyActionTypes.setDescription,
				description: e.target.value,
			})
		},
		[storeDispatch],
	)
	function handleChange(event: any) {
		storeDispatch({
			type: ECompanyActionTypes.setIndustryId,
			industryId: event.target.value,
		})
	}
	//todo yo baki xa
	const checkCompanyNameAvailability = useCallback(async () => {
		const { data } = await client.query({
			query: CompanyQuery,
			variables: {
				language: i18n.language,
				name,
			},
		})
		return !Boolean(data.company)
	}, [client, name, i18n.language])

	const invalidForm = useCallback(() => {
		return (
			_.isEmpty(name) ||
			_.isEmpty(noOfEmployees) ||
			_.isEmpty(typeId) ||
			_.isEmpty(industryId) ||
			_.isEmpty(logoPath) ||
			!isHeadquartersAvailable ||
			!hasLogo
		)
	}, [
		isHeadquartersAvailable,
		hasLogo,
		logoPath,
		industryId,
		name,
		noOfEmployees,
		typeId,
	])

	const handleNextStep = useCallback(async () => {
		if (loading === false) {
			if (!invalidForm() && step === STEP_2) {
				toggle(true)
				return
			}
			if (step === STEP_1 && !invalidForm()) {
				let isCompanyNameAvailable =
					await checkCompanyNameAvailability()
				setCheckCompanyLoading(true)
				setIsCompanyNameAvailable(isCompanyNameAvailable)
				setCheckCompanyLoading(false)
				if (!isCompanyNameAvailable) return
				setStep(STEP_2)
			} else setStep(STEP_1)
		}
	}, [checkCompanyNameAvailability, invalidForm, loading, step])

	const handleAvatarUploadedState = useCallback(() => {
		setIsAvatarUploaded(true)
	}, [])

	const canEdit = storeUserId ? true : false

	// Todo Kundan1023
	// Please check the payload.
	const [AddCompanyMutation] = useInsertIntoCompanyCollectionMutation({
		update(cache, { data }) {
			// TODO: clean the company data from store and update checkCredentials (user's profile) from cache
			const query = CheckCredentialsQuery
			try {
				let parsedAddCompany: {
					id: string
					name: string
					slug: string
					__typename: string
				}
				// parsedAddCompany = {
				// 	id: addCompany.id,
				// 	name: addCompany.name,
				// 	slug: addCompany.slug,
				// 	__typename: addCompany.__typename,
				// }

				parsedAddCompany = {
					id: data?.insertIntoCompanyCollection?.records?.[0]
						?.id as string,
					name: data?.insertIntoCompanyCollection?.records?.[0]
						?.name as string,
					slug: data?.insertIntoCompanyCollection?.records?.[0]
						?.slug as string,
					__typename: data?.insertIntoCompanyCollection?.records?.[0]
						?.__typename as string,
				}

				const user = storeUser

				const ownedCompanies: any = user
					? [...user.profile.ownedCompanies, parsedAddCompany]
					: [data?.insertIntoCompanyCollection]
				storeDispatch({
					type: EAppStateActionTypes.updateUser,
					user: {
						...user,
						profile: {
							...user.profile,
							ownedCompanies,
						},
					},
				})
				cache.writeQuery({
					query,
					data: {
						checkCredentials: {
							...user,
							profile: {
								...user.profile,
								ownedCompanies,
							},
						},
					},
				})
			} catch (e) {
				console.error(e)
			}
		},
	})
	useEffect(() => {
		if (loading) {
			const mutate = async () => {
				// let officesObj =
				// 	offices?.selected &&
				// 	offices?.selected?.map((item: any) => ({
				// 		locationId: item.id,
				// 	}))
				// let hqObj = headquarters?.selected
				// 	?.map((item: any) => ({
				// 		locationId: item.id,
				// 	}))
				// 	.shift()

				try {
					let result: any = await AddCompanyMutation({
						variables: {
							details: {
								id: id,
								// language: i18n.language,
								name: name || '',
								description: description || '',
								industry: industryId || '',
								//Todo missing keys: companyTypeId, offices, headquaters
								// companyTypeId: typeId || '',
								noOfEmployees: noOfEmployees || '',
								hasLogo: hasLogo || '',
								logoPath: logoPath || '',
								// offices: officesObj,
								// headquarters: hqObj,
								// error: error
							},
						},
					})
					history.push(
						`/${i18n.language}/employers/${
							result.data.addCompany &&
							result.data.addCompany.slug
						}`,
					)
				} catch (error) {
					console.error(error)
					toggle(false)
				}
			}
			mutate()
		}
	}, [
		loading,
		id,
		description,
		name,
		noOfEmployees,
		typeId,
		history,
		i18n.language,
		AddCompanyMutation,
		industryId,
		logoPath,
		hasLogo,
		offices,
		headquarters,
		error,
	])

	useEffect(() => {
		if (id === '')
			storeDispatch({
				type: ECompanyActionTypes.setId,
				id: cuid(),
			})
	}, [storeDispatch, id])

	// reset the id from company store
	useEffect(() => {
		return () => {
			storeDispatch({
				type: ECompanyActionTypes.setId,
				id: '',
			})
		}
	}, [storeDispatch])

	const handleDeleteLogo = useCallback(() => {
		storeDispatch({
			type: ECompanyActionTypes.setUploadLogo,
			hasLogo: false,
			logoPath: '',
		})
		setIsAvatarUploaded(false)
	}, [storeDispatch])

	// checks if ownedCompanies === true and redirect to index

	// COMMENTED BECAUSE its affect to load create company page //

	// useLayoutEffect(() => {
	// 	if (storeUser) {
	// 		if (!storeUserIg && storeUser.profile?.ownedCompanies.length !== 0) {
	// 			history.push(`/${i18n.language}`)
	// 		}
	// 	}
	// }, [storeUser, storeUserIg, history, i18n.language])

	return (
		<Grid container={true} justifyContent="center" direction="row">
			<div className={classes.companyRoot}>
				<Header
					displayName={step !== STEP_1 ? true : false}
					companyName={name}
				/>
				<Grid item xs={12} className={classes.formSection}>
					{checkCompanyLoading ? (
						<Loading size={48} style={{ marginTop: '100px' }} />
					) : (
						<Grid
							container
							justifyContent="center"
							spacing={2}
							className={classes.createCompanyContainer}
						>
							<Grid
								item
								xs={12}
								className={
									step === STEP_1
										? classes.displayForm
										: classes.hideForm
								}
							>
								<Grid container spacing={4}>
									<Grid item xs={12}>
										<div className={classes.uploadSection}>
											<EntityLogo
												alt={name + ' logo'}
												type={EEntity.company}
												company={{
													id,
													hasLogo,
													logoPath,
												}}
												onAdd={(logoPath: string) => {
													handleLogoUpload(
														true,
														logoPath,
													)
												}}
												disabledEdit={
													canEdit ? false : true
												}
												handleAvatarUploadedState={
													handleAvatarUploadedState
												}
												isAvatarUploaded={
													isAvatarUploaded
												}
											/>
										</div>
										{!isAvatarUploaded ? (
											<div>
												<Translation key="logoRequired">
													{t => (
														<div
															className={classNames(
																classes.requiredLogoText,
																{
																	[classes.labelFieldError]:
																		error &&
																		error.logoPath,
																},
															)}
														>
															{t('Required')}
														</div>
													)}
												</Translation>
											</div>
										) : (
											<Button
												variant="outlined"
												color="secondary"
												classes={{
													root: classes.deleteLogoButton,
												}}
												onClick={handleDeleteLogo}
											>
												{t('Delete')}
											</Button>
										)}
									</Grid>
									<Grid item xs={12} sm={6}>
										<FormControl
											className={classes.formControl}
										>
											<InputLabel htmlFor="companyName">
												<Translation key="lastNameRequired">
													{t => (
														<div
															className={classNames(
																classes.labelField,
																{
																	[classes.labelFieldError]:
																		error &&
																		error.name,
																},
															)}
														>
															{t(
																'Name of the Company',
															)}
															<span
																className={classNames(
																	classes.requiredField,
																	{
																		[classes.labelFieldError]:
																			error &&
																			error.name,
																	},
																)}
															>
																{`(${t(
																	'Required',
																)})`}
															</span>
														</div>
													)}
												</Translation>
											</InputLabel>
											<Input
												id="companyName"
												className={classNames(
													classes.textField,
													{
														[classes.labelFieldError]:
															error && error.name,
													},
												)}
												value={name}
												onChange={updateCompanyName}
											/>
										</FormControl>
										{isCompanyNameAvailable !== '' &&
											!isCompanyNameAvailable && (
												<span
													style={{ color: 'red' }}
													id="name-error-text"
												>
													{'Name not available'}
												</span>
											)}
									</Grid>
									<Grid item xs={12} sm={6}>
										<FormControl
											className={classes.formControl}
										>
											<InputLabel htmlFor="industry-filed">
												<Translation key="lastNameRequired">
													{t => (
														<div
															className={classNames(
																classes.labelField,
																{
																	[classes.labelFieldError]:
																		error &&
																		error.industry,
																},
															)}
														>
															{t('Industry')}
															<span
																className={classNames(
																	classes.requiredField,
																	{
																		[classes.labelFieldError]:
																			error &&
																			error.industry,
																	},
																)}
															>
																{`(${t(
																	'Required',
																)})`}
															</span>
														</div>
													)}
												</Translation>
											</InputLabel>
											<Select
												value={industryId}
												error={error && error.industry}
												onChange={handleChange}
												inputProps={{
													name: 'industry',
													id: 'industry-filed',
													className: classes.input,
												}}
												IconComponent={
													KeyboardArrowDown
												}
											>
												<MenuItem value="">
													<em>{t('None')}</em>
												</MenuItem>

												{industriesData
													.industryCollection
													?.edges &&
													industriesData?.industryCollection?.edges?.map(
														item => {
															return (
																<MenuItem
																	key={
																		item
																			.node
																			.id
																	}
																	value={
																		item
																			.node
																			.id
																	}
																>
																	{
																		item
																			.node
																			.key
																	}
																</MenuItem>
															)
														},
													)}
											</Select>
										</FormControl>
									</Grid>
									<Grid item xs={12}>
										<div className={classes.labelText}>
											{t('Company type')}
										</div>
										<div>
											{companyTypesData
												.companyTypeCollection?.edges &&
												companyTypesData?.companyTypeCollection?.edges?.map(
													(item: any, index: any) => {
														return (
															<Chip
																key={item.title}
																variant="outlined"
																className={`${
																	classes.chip
																} ${
																	item.id ===
																	typeId
																		? classes.chipActive
																		: classes.chipInactive
																} `}
																label={
																	item.title
																}
																size={'small'}
																clickable={true}
																onClick={() =>
																	updateCompanyType(
																		item.id,
																	)
																}
															/>
														)
													},
												)}
										</div>
									</Grid>
									<Grid item xs={12}>
										<div className={classes.labelText}>
											{t('Company size')}
										</div>
										<div>
											{Object.keys(companySize)?.map(
												item => {
													return (
														<Chip
															key={
																companySize[
																	item
																]
															}
															variant="outlined"
															className={`${
																classes.chip
															} ${
																item ===
																noOfEmployees
																	? classes.chipActive
																	: classes.chipInactive
															} `}
															label={
																companySize[
																	item
																]
															}
															size={'small'}
															clickable={true}
															onClick={() =>
																updateCompanySize(
																	item,
																)
															}
														/>
													)
												},
											)}
										</div>
									</Grid>
									<Grid item xs={12}>
										<div>
											<Translation key="headquarterRequired">
												{t => (
													<div
														className={classNames(
															classes.labelText,
															{
																[classes.labelFieldError]:
																	error &&
																	error.headquarters,
															},
														)}
													>
														{t(
															'City of the headquarter (a single location)',
														)}
														<span
															className={classNames(
																classes.requiredField,
																{
																	[classes.labelFieldError]:
																		error &&
																		error.headquarters,
																},
															)}
														>
															{`(${t(
																'Required',
															)})`}
														</span>
													</div>
												)}
											</Translation>
										</div>
										<Locations
											headquartersOfficeType={true}
											// handleSetOffice={handleSetOffice}
										/>
									</Grid>
									<Grid item xs={12}>
										<div className={classes.labelText}>
											{t('Location of office(s)')}
										</div>
										<Locations
										// handleSetOffice={handleSetOffice}
										/>
									</Grid>
								</Grid>
							</Grid>
							<Grid
								item
								xs={12}
								className={
									step === STEP_2
										? classes.displayForm
										: classes.hideForm
								}
							>
								<Grid container>
									<Grid item xs={12}>
										<FormControl
											className={classes.formControl}
										>
											<InputLabel htmlFor="companyDescription">
												<Translation key="compDescription">
													{t => (
														<div
															className={
																classes.labelField
															}
														>
															{t(
																'Describe your company',
															)}
														</div>
													)}
												</Translation>
											</InputLabel>
											<Input
												id="companyDescription"
												className={classes.textField}
												onChange={
													updateCompanyDescription
												}
												fullWidth
												multiline
												rows="4"
												value={description}
											/>
										</FormControl>
									</Grid>
								</Grid>
							</Grid>
							<Grid
								item
								xs={12}
								className={classes.submitSection}
							>
								<span
									onClick={handleNextStep}
									style={{ cursor: 'pointer' }}
									className={`${classes.infoText} ${
										step === STEP_2
											? classes.displayForm
											: classes.hideForm
									}`}
								>
									{t(`I'll will do it later`)}
								</span>
								<button
									className={classes.submitBtn}
									onClick={handleNextStep}
								>
									{step === STEP_1 ? 'Next' : 'Save'}
								</button>
							</Grid>
						</Grid>
					)}
				</Grid>
			</div>
		</Grid>
	)
}
// CompanyStateValue
const CompanyCreate = memo((props: any) => (
	<StoreValue
		keys={[
			'user|storeUser',
			'user.id|storeUserId',
			'user._ig|storeUserIg',
			'storeDispatch',
			'company.id|id',
			'company.name|name',
			'company.description|description',
			'company.ownerId|ownerId',
			'company.typeId|typeId',
			'company.industryId|industryId',
			'company.noOfEmployees|noOfEmployees',
			'company.offices|offices',
			'company.hasLogo|hasLogo',
			'company.logoPath|logoPath',
			'company.headquarters|headquarters',
			'company.error|error',
		]}
	>
		<CompanyCreateView {...props} />
	</StoreValue>
))

export default CompanyCreate
